<footer>
  <h3>Tine's Ferienwohnung</h3>
  <ul class="site-map">
    <li><a routerLink="/contact">Kontakt</a></li>
    <li><a routerLink="/impressum">Impressum</a></li>
  </ul>
</footer>
